(function () {
  var root = document.querySelector('[data-mk-aiw]');
  if (!root) return;

  var fab = root.querySelector('[data-mk-aiw-toggle]');
  var panel = root.querySelector('[data-mk-aiw-panel]');
  var closeBtn = root.querySelector('[data-mk-aiw-close]');
  var title = root.querySelector('[data-mk-aiw-title]');
  var views = root.querySelectorAll('[data-aiw-view]');
  var pool = JSON.parse(root.querySelector('[data-aiw-pool]').textContent || '[]');
  var giftPool = JSON.parse(root.querySelector('[data-aiw-giftpool]').textContent || '[]');

  var TITLES = { menu: "Hi, I'm here to help", scent: 'Find your scent', gift: 'Pick a gift set', ask: 'Ask a question' };

  function openPanel() {
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    try { localStorage.removeItem('mk_aiw_closed'); } catch (e) {}
  }
  function closePanel() {
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    try { localStorage.setItem('mk_aiw_closed', '1'); } catch (e) {}
  }
  function goView(name) {
    views.forEach(function (v) { v.hidden = v.getAttribute('data-aiw-view') !== name; });
    title.textContent = TITLES[name] || TITLES.menu;
  }

  fab.addEventListener('click', function () {
    if (panel.hidden) { openPanel(); } else { closePanel(); }
  });
  closeBtn.addEventListener('click', closePanel);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-aiw-go]')) goView(e.target.closest('[data-aiw-go]').getAttribute('data-aiw-go'));
    if (e.target.closest('[data-aiw-back]')) goView('menu');
  });

  /* ---------- shared scoring engine (same logic as the old scent quiz) ---------- */
  var KW = {
    mood: {
      calm: ['lavender', 'eucalyptus', 'jasmine', 'noor', 'antidote', 'inhale'],
      fresh: ['lemongrass', 'citrus', 'mint', 'sunshine', 'fresh', 'beach', 'sorbet'],
      cozy: ['rose', 'musk', 'peach', 'pomander', 'orchard', 'velvet', 'colada', 'noor'],
      clean: ['sea salt', 'mint', 'eucalyptus', 'bergamot', 'beach', 'muse', 'fresh']
    },
    family: {
      floral: ['jasmine', 'rose', 'orchid', 'noor', 'muse', 'floral'],
      citrus: ['lemongrass', 'citrus', 'orange', 'bergamot', 'mint', 'sorbet', 'sunshine'],
      sweet: ['peach', 'colada', 'coconut', 'pomander', 'orchard', 'sweet'],
      herbal: ['lavender', 'eucalyptus', 'mint', 'clove', 'musk', 'herbal', 'antidote']
    },
    format: { candle: ['jar candle', 'candle'], tablet: ['tablet', 'melt'], diffuser: ['diffuser', 'spray', 'oil', 'mist'] },
    room: {
      bedroom: ['lavender', 'jasmine', 'rose', 'tablet'],
      living: ['candle', 'diffuser', 'pomander', 'orchard'],
      desk: ['lemongrass', 'mint', 'citrus', 'tablet', 'sunshine'],
      bath: ['spray', 'sea salt', 'eucalyptus', 'mint', 'diffuser']
    }
  };
  function hits(hay, words) { var n = 0; (words || []).forEach(function (w) { if (hay.indexOf(w) > -1) n++; }); return n; }
  function scoreScent(p, ans) {
    var s = 0;
    if (ans.format && ans.format !== 'any') {
      var f = hits(p.hay, KW.format[ans.format]);
      if (!f) return -1;
      s += 3;
    }
    s += 2 * Math.min(hits(p.hay, KW.family[ans.family] || []), 2);
    s += 2 * Math.min(hits(p.hay, KW.mood[ans.mood] || []), 2);
    s += Math.min(hits(p.hay, KW.room[ans.room] || []), 1);
    if (p.hay.indexOf('bestseller') > -1) s += 1;
    return s;
  }
  function renderHits(container, items) {
    container.innerHTML = items.map(function (p) {
      // "+" add-to-cart uses the global data-mk-atc handler (assets/mk-cart.js),
      // which adds the variant and refreshes/opens the cart drawer. Only shown
      // when we have a variant id for the product.
      var add = p.id
        ? '<button type="button" class="mk-aiw-hit__add" data-mk-atc data-variant-id="' + p.id + '" aria-label="Add ' + String(p.t).replace(/"/g, '') + ' to cart" title="Add to cart">+</button>'
        : '';
      return '<div class="mk-aiw-hit">' +
        '<a class="mk-aiw-hit__link" href="' + p.u + '">' +
          '<img class="mk-aiw-hit__img" src="' + p.img + '" alt="" loading="lazy" width="52" height="52">' +
          '<span><p class="mk-aiw-hit__title">' + p.t + '</p><p class="mk-aiw-hit__price">' + p.p + '</p></span>' +
        '</a>' + add +
      '</div>';
    }).join('');
  }

  /* ---------- scent finder ---------- */
  (function () {
    var view = root.querySelector('[data-aiw-view="scent"]');
    var steps = ['room', 'mood', 'family', 'format', 'result'];
    var ans = {}, cur = 0;
    function show(i) {
      cur = i;
      view.querySelectorAll('[data-scent-step]').forEach(function (st) {
        st.hidden = st.getAttribute('data-scent-step') !== steps[i];
      });
    }
    function render() {
      var ranked = pool.map(function (p) { return [scoreScent(p, ans), p]; })
        .filter(function (x) { return x[0] >= 0; })
        .sort(function (a, b) { return b[0] - a[0]; });
      if (ranked.length < 2) ranked = pool.map(function (p) { return [scoreScent(p, ans), p]; }).sort(function (a, b) { return b[0] - a[0]; });
      renderHits(view.querySelector('[data-scent-results]'), ranked.slice(0, 3).map(function (x) { return x[1]; }));
      show(4);
      if (window.mkTrack) window.mkTrack('scent_quiz', ans);
    }
    view.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-scent-q]');
      if (tile) {
        ans[tile.getAttribute('data-scent-q')] = tile.getAttribute('data-scent-v');
        if (cur < 3) show(cur + 1); else render();
      }
      if (e.target.closest('[data-scent-retake]')) { ans = {}; show(0); }
    });
  })();

  /* ---------- gift helper ---------- */
  (function () {
    var view = root.querySelector('[data-aiw-view="gift"]');
    var state = {};
    function showStep(name) {
      view.querySelectorAll('[data-gift-step]').forEach(function (st) {
        st.hidden = st.getAttribute('data-gift-step') !== name;
      });
    }
    var OCC_KW = {
      diwali: ['diwali', 'festive', 'gold'],
      corporate: ['corporate', 'bulk', 'business'],
      birthday: ['birthday', 'celebration'],
      any: []
    };
    function renderReady() {
      var resultsEl = view.querySelector('[data-gift-results]');
      var ctaEl = view.querySelector('[data-gift-cta]');
      view.querySelector('[data-gift-result-title]').textContent = 'Ready-made sets for you';
      var kw = OCC_KW[state.occ] || [];
      var ranked = giftPool.map(function (p) { return [hits(p.hay, kw), p]; }).sort(function (a, b) { return b[0] - a[0]; });
      var top = ranked.slice(0, 2).map(function (x) { return x[1]; });
      if (top.length === 0) {
        resultsEl.innerHTML = '<p class="mk-aiw__lead">No gift sets published yet — check back soon, or ask us on WhatsApp.</p>';
      } else {
        renderHits(resultsEl, top);
      }
      ctaEl.hidden = false;
      ctaEl.href = '/collections/gift-sets';
      ctaEl.textContent = 'See all gift sets →';
      showStep('result');
      if (window.mkTrack) window.mkTrack('gift_quiz', { type: 'ready', occ: state.occ });
    }
    function renderCustom() {
      var resultsEl = view.querySelector('[data-gift-results]');
      var ctaEl = view.querySelector('[data-gift-cta]');
      view.querySelector('[data-gift-result-title]').textContent = 'A set to start from';
      var ans = { mood: state.mood, family: '', format: 'any', room: '' };
      var ranked = pool.map(function (p) { return [scoreScent(p, ans), p]; }).sort(function (a, b) { return b[0] - a[0]; });
      var top = ranked.slice(0, 3).map(function (x) { return x[1]; });
      renderHits(resultsEl, top);
      var picks = top.map(function (p) { return p.id; }).join(',');
      ctaEl.hidden = false;
      ctaEl.href = '/products/build-your-own-set' + (picks ? '?picks=' + picks : '');
      ctaEl.textContent = 'Open the builder with these picked →';
      showStep('result');
      if (window.mkTrack) window.mkTrack('gift_quiz', { type: 'custom', mood: state.mood });
    }
    view.addEventListener('click', function (e) {
      var typeBtn = e.target.closest('[data-gift-type]');
      if (typeBtn) {
        state.type = typeBtn.getAttribute('data-gift-type');
        showStep(state.type === 'ready' ? 'occasion' : 'mood');
        return;
      }
      var occBtn = e.target.closest('[data-gift-occ]');
      if (occBtn) { state.occ = occBtn.getAttribute('data-gift-occ'); renderReady(); return; }
      var moodBtn = e.target.closest('[data-gift-mood]');
      if (moodBtn) { state.mood = moodBtn.getAttribute('data-gift-mood'); renderCustom(); return; }
      if (e.target.closest('[data-gift-retake]')) { state = {}; showStep('type'); }
    });
  })();

  /* ---------- ask a question ---------- */
  (function () {
    var view = root.querySelector('[data-aiw-view="ask"]');
    if (!view) return; // "Ask a question" removed — questions go to WhatsApp instead
    var thread = view.querySelector('[data-ask-thread]');
    var form = view.querySelector('[data-ask-form]');
    var input = view.querySelector('[data-ask-input]');

    // Hardcoded fallback — used only if the editable FAQ blob is empty or malformed,
    // so a bad edit in the theme customizer can never break the widget.
    var FAQ_FALLBACK = [
      { kw: ['ship', 'deliver', 'dispatch', 'when will'], a: 'We dispatch in 1–3 working days and deliver pan-India in 3–7 days. Free shipping on orders over ₹799; a flat ₹99 below that.' },
      { kw: ['1999', 'free gift', 'free tablet'], a: 'Spend over ₹1,999 and a free wax tablet is added to your order automatically, no code needed.' },
      { kw: ['return', 'refund', 'exchange', 'damage', 'broken'], a: 'Unused, sealed items can be returned within 7 days. If something arrives damaged, email us within 48 hours of delivery and we’ll make it right.' },
      { kw: ['coupon', 'code', 'discount', 'promo'], a: 'Sign up with your email for a 10% off welcome code (WELCOME10) on your first order. Beyond that, discounts are automatic, no code needed: free shipping over ₹799 (flat ₹99 below), a free wax tablet over ₹1,999, and tiered pricing on corporate or bulk orders.' },
      { kw: ['natural', 'ingredient', 'wax', 'toxin', 'vegan', 'ifra', 'chemical'], a: 'Our candles and tablets use 100% natural wax with COA-verified materials. Fragrance oils are IFRA-compliant and synthetic, safe and consistent, though not “natural fragrance.”' },
      { kw: ['handmade', 'handcraft', 'made in', 'small batch', 'where'], a: 'Every piece is hand-poured in small batches in India.' }
    ];
    // Editable FAQ: rendered from settings.aiw_faq into the [data-aiw-faq] JSON blob.
    var FAQ = FAQ_FALLBACK;
    try {
      var faqEl = root.querySelector('[data-aiw-faq]');
      var parsed = faqEl ? JSON.parse(faqEl.textContent || '[]') : [];
      if (parsed && parsed.length) FAQ = parsed;
    } catch (e) { FAQ = FAQ_FALLBACK; }

    function addBubble(text, who) {
      var el = document.createElement('div');
      el.className = 'mk-aiw__bubble mk-aiw__bubble--' + who;
      el.innerHTML = text;
      thread.appendChild(el);
      thread.scrollTop = thread.scrollHeight;
    }

    function findFaq(q) {
      var lower = q.toLowerCase();
      for (var i = 0; i < FAQ.length; i++) {
        if (FAQ[i].kw.some(function (w) { return lower.indexOf(w) > -1; })) return FAQ[i].a;
      }
      return null;
    }

    function waFallback() {
      return 'Let me get a real person on this — <a href="' + window.MK_WA_LINK + '" target="_blank" rel="noopener noreferrer">tap to message us on WhatsApp</a> and we’ll reply shortly.';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      addBubble(q, 'user');
      input.value = '';

      var faqHit = findFaq(q);
      if (window.mkTrack) window.mkTrack('question', { q: q, answered: !!faqHit });
      if (faqHit) { addBubble(faqHit, 'bot'); return; }

      if (window.MK_AI_WORKER_URL) {
        addBubble('…', 'bot');
        var loadingBubble = thread.lastChild;
        fetch(window.MK_AI_WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ question: q })
        }).then(function (r) { return r.json(); }).then(function (data) {
          loadingBubble.innerHTML = data.answer || waFallback();
        }).catch(function () {
          loadingBubble.innerHTML = waFallback();
        });
      } else {
        addBubble(waFallback(), 'bot');
      }
    });
  })();
})();
